import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-setting',
  templateUrl: './common-setting.component.html',
  styleUrls: ['./common-setting.component.css']
})
export class CommonSettingComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
    
  }

}
